import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {IconClose, IconIndicatorBlue} from "../../Icon";
import {Checkbox, Modal, Spin, Tooltip} from "antd";
import {t} from "i18next";
import {DEFAULT_IMPORT_MODE, KEY_FILE_IMPORT_MODE, MAX_Z_INDEX} from "@/Const";
import {getImagePath, getImagePathWithTheme, isDarkMode} from "@/utils";

let mOnCallback:any;
const DialogDragFileImportMode = forwardRef((props:{onCloseEvent:any}, ref)=>{

    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        onCloseDialog:onCloseDialog
    }))

    const onShowDialog = (onCallback:any)=>{
        setIsShowDialog(true);
        mOnCallback = onCallback;

        // var arrayNew:any = [...DEFAULT_IMPORT_MODE()];
        // arrayNew[0].isSelected = true;
        // setArrayMode(arrayNew);
        var arrayNew = [...DEFAULT_IMPORT_MODE()];
        arrayNew[0].isSelected = true;
        setArrayMode(arrayNew);
    }
    const onCloseDialog = ()=>{
        setIsShowDialog(false);
    }

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [arrayMode,setArrayMode] = useState([]);
    const [isRemember,setIsRemeber] = useState(false);

    useEffect(()=>{

    },[])

    return(
        <Modal centered={true} width='468px' zIndex={MAX_Z_INDEX} open={isShowDialog} closable={true} closeIcon={<IconClose/>} onCancel={()=> {
            setIsShowDialog(false);
            if (props.onCloseEvent) {
                props.onCloseEvent();
            }
        }} footer={null}>
            <div className='font-size-12' style={{
                flexDirection: 'column'
            }}>
                <span className='header-title'>{t("Import files")}</span>
                <div className='line' style={{margin: '12px -16px'}}></div>
                <div className={'flex-row-vertical-center'} style={{justifyContent: 'space-between'}}>
                    {
                        arrayMode.map(p => {
                            return <div className={'flex-column-center cursor-pointer'} style={{
                                background: (p.isHover || p.isSelected) ? 'var(--file-import-mode-background-hover-color)' : 'var(--file-import-mode-background-color)',
                                width: '204px',
                                height: '80px',
                                borderRadius: '8px',
                                border:(p.isHover || p.isSelected)?'1px solid #3670F7':'none'
                            }} onMouseEnter={() => {
                                var arrayNew = [...arrayMode];
                                arrayNew.forEach(p=>{
                                    p.isHover = false;
                                })
                                const item = arrayNew.find(m => m.id == p.id);
                                if (item) {
                                    item.isHover = true;
                                }
                                setArrayMode(arrayNew);

                            }} onMouseLeave={() => {
                                var arrayNew = [...arrayMode];
                                arrayNew.forEach(p=>{
                                    p.isHover = false;
                                })
                                setArrayMode(arrayNew);
                            }} onClick={() => {
                                var arrayNew:any = [...arrayMode];
                                arrayNew.forEach(p=>{
                                    p.isSelected = false;
                                })
                                const item = arrayNew.find(m => m.id == p.id);
                                if (item) {
                                    item.isSelected = true;
                                }
                                setArrayMode(arrayNew);
                            }}>
                                <img style={{width: '44px', height: '44px'}}
                                     src={getImagePathWithTheme(p.img + ((p.isHover || p.isSelected) ? '_hover' : ''))}/>
                                <div className={'flex-row-vertical-center'}>
                                    <span className={'font-family-semi-bold font-size-13'}
                                        style={{color: (p.isHover || p.isSelected) ? '#3670F7' : (isDarkMode() ? '#FBFBFB' : '#393834')}}>{p.title}</span>
                                    <Tooltip arrow={false} arrow={false} title={p.tips} placement={"bottom"}>
                                        <img className={'img-14 ml-2'} src={getImagePath('file_mode_help')}/>
                                    </Tooltip>

                                </div>
                            </div>
                        })
                    }
                </div>

                <div className={'flex-row-vertical-center mt-22'}>
                    {/*<div className={'flex-row-vertical-center cursor-pointer'} onClick={()=>{*/}
                    {/*    setIsRemeber(!isRemember);*/}
                    {/*}}>*/}
                    {/*    <Checkbox checked={isRemember}/>*/}
                    {/*    <span className={'ml-8'}>{t("Remember my choice")}</span>*/}
                    {/*</div>*/}

                    <div style={{color: 'var(--color-666666)'}}>
                        <span>{t("AdvancedOptionsInSettings")}</span>
                        <span className={'cursor-pointer'} style={{textDecoration: 'underline'}} onClick={() => {
                            if (props.onCloseEvent) {
                                props.onCloseEvent();
                            }
                            window.showSettingDialog('importFile');
                        }}>{t("Settings")}</span>
                    </div>

                    <div style={{flexGrow: '1'}}></div>

                    <div style={{minWidth: '90px'}} className={'flex-center button-border-gray-style'}
                         onClick={() => setIsShowDialog(false)}>{t("Cancel")}</div>
                    <div style={{minWidth: '90px'}} className={'flex-center button-solid-style ml-12'} onClick={() => {
                        if (props.onCloseEvent) {
                            props.onCloseEvent();
                        }
                        const item = arrayMode.find(m => m.isSelected);
                        mOnCallback(item.id)
                    }}>{t("Import")}</div>
                </div>
            </div>
        </Modal>
    )
})

export default DialogDragFileImportMode;























